// eslint-disable-next-line max-len
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from "@angular-material-components/datetime-picker";
import { NgxMatMomentModule } from "@angular-material-components/moment-adapter";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { LayoutModule } from "@angular/cdk/layout";
import { DatePipe, DecimalPipe } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER, ErrorHandler, Injector, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatMomentDateModule, MomentDateAdapter } from "@angular/material-moment-adapter";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule, MAT_BOTTOM_SHEET_DEFAULT_OPTIONS } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS } from "@angular/material/tooltip";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { FiltersDisplayModule, ItemFilterModule } from "@comunicare/comunicare-angular-filters-display";
import { ImageViewerComponentModule } from "@comunicare/comunicare-angular-img-viewer";
import {
  APPOINTMENT_SERVICE,
  CAREPLAN_EDITOR_SERVICE,
  CAREPLAN_SERVICE,
  HEALTHCARESERVICE_SERVICE,
  HELP_DATA_SERVICE,
  KNOWLEDGE_CRITERIA_SERVICE,
  KNOWLEDGE_SERVICE,
  LANGUAGE_SERVICE,
  OBSERVATION_SERVICE,
  ORGANIZATION_SERVICE,
  PREFERENCE_SERVICE,
  QUESTIONNAIRE_API_SERVICE,
  QUESTIONNAIRE_SERVICE,
  RESPONSIVE_DIALOG_SERVICE,
  RESPONSIVE_SERVICE,
  RULE_SERVICE,
  SESSION_SERVICE,
  USER_SERVICE,
  USER_STAT_SERVICE,
} from "@comunicare/comunicare-angular-injection-tokens";
import { EmailInputModule, PhoneInputModule, StarRatingModule, WhenInputModule } from "@comunicare/comunicare-angular-inputs";
import { EncodeObservationsComponentModule } from "@comunicare/comunicare-angular-observation-encoder";
import {
  ConfirmationDialogModule,
  GlobalHelpDialogModule,
  KnowledgeMediaListModule,
  KnowledgeOverviewModule,
  PhotoBoothDialogComponentModule,
  UiAlertModule,
  WarningBoxDialogModule,
} from "@comunicare/comunicare-dashboard-modals";
import { FileLogger } from "@comunicare/comunicare-helper";
import {
  DraftWarningDialogModule,
  KnowledgeComparisonDialogModule,
  KnowledgeCriteriaModule,
  KnowledgeDetailsPageModule,
  KnowledgeMediaEditorModule,
  KnowledgeServicesModule,
  MediaSelectorDialogModule,
} from "@comunicare/comunicare-knowledge-editor";
import { KnowledgeListPipesModule } from "@comunicare/comunicare-knowledge-list";
import { ParamEditorModule } from "@comunicare/comunicare-param-editor";
import { FhirQuestionnaireListPageModule } from "@comunicare/comunicare-questionnaire-list";
import { PagesEditorComponentModule, QuestionnaireEditorPageModule } from "@comunicare/comunicare-questionnaireeditor";
import { TimingEditorModule } from "@comunicare/comunicare-timing-editor";
import { MdePopoverModule } from "@material-extended/mde";
import { TranslateService } from "@ngx-translate/core";
import { JoditAngularModule } from "jodit-angular";
import { ChartsModule } from "ng2-charts";
import { CookieService } from "ngx-cookie-service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { environment } from "src/environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CareplanEditorService } from "./careplan-editor/domain/careplan-editor.service";
import { CareplanEditorPageModule } from "./careplan-editor/views/careplan-editor-page/careplan-editor-page.module";
import { CareplansListPageComponent } from "./careplan-editor/views/careplans-list-page/views/careplans-list-page/careplans-list-page.component";
import { AddToGroupDialogComponent } from "./components/add-to-group-dialog/add-to-group-dialog.component";
import { GroupSearchOnlyComponent } from "./components/add-to-group-dialog/group-search-only/group-search-only.component";
import { GroupServerSideSearchComponent } from "./components/add-to-group-dialog/group-server-side-search-component/group-server-side-search.component";
import { AnsPractitionnerResultComponent } from "./components/ans-practitionner-result/ans-practitionner-result.component";
import { AppointmentDelayDialogComponent } from "./components/appointment-delay-dialog/appointment-delay-dialog.component";
import { AppointmentDelayComponent } from "./components/appointment-delay/appointment-delay.component";
import { CareplanActivityComponent } from "./components/careplan/careplan-activity/careplan-activity.component";
import { CareplanComponent } from "./components/careplan/careplan.component";
import { ChangeLangComponent } from "./components/change-lang/change-lang.component";
import { StreamObsChartComponent } from "./components/charts/stream-obs-chart/stream-obs-chart.component";
import { StreamObsStatChartComponent } from "./components/charts/stream-obs-stat-chart/stream-obs-stat-chart.component";
import { CommunicationOverviewComponent } from "./components/communication-overview/communication-overview.component";
import { ConfirmResetPasswordDialogComponent } from "./components/confirm-reset-password-dialog/confirm-reset-password-dialog.component";
import { ConfirmTogglePractitionerDialogComponent } from "./components/confirm-toggle-practitioner-dialog/confirm-toggle-practitioner-dialog.component";
import { DefinitionListComponent } from "./components/definition-list/definition-list.component";
import { DisplayAuthcodeConfirmationComponent } from "./components/display-authcode-confirmation/display-authcode-confirmation.component";
import { DisplayEnvironementDialogComponent } from "./components/display-environement-dialog/display-environement-dialog.component";
import { DisplayPicturesComponent } from "./components/display-pictures/display-pictures.component";
import { ErrorGeneratePasswordComponent } from "./components/error-generate-password/error-generate-password.component";
import { ErrorOnGettingCaremateIDComponent } from "./components/error-on-getting-caremate-id/error-on-getting-caremate-id.component";
import { AddCommunicationComponent } from "./components/forms/add-communication/add-communication.component";
import { AddDrugSchemaComponent } from "./components/forms/add-drug-schema/add-drug-schema.component";
import { PauseDrugSchemaComponent } from "./components/forms/add-drug-schema/pause-drug-schema/pause-drug-schema.component";
import { AddGroupComponent } from "./components/forms/add-group/add-group.component";
import { KnowledgeCreationDialogComponent } from "./components/forms/add-knowledge/add-knowledge.component";
import { AddOrganizationComponent } from "./components/forms/add-organization/add-organization.component";
import { ChooseInsuranceDialogComponent } from "./components/forms/add-patient/patient-already-exists-dialog/choose-insurance-dialog/choose-insurance-dialog.component";
import { PatientAlreadyExistsDialogComponent } from "./components/forms/add-patient/patient-already-exists-dialog/patient-already-exists-dialog.component";
import { TownServerSideSearchComponent } from "./components/forms/add-patient/town-server-side-search-component/town-server-side-search.component";
import { AddServiceComponent } from "./components/forms/add-service/add-service.component";
import { AddStepwiseDrugComponent } from "./components/forms/add-stepwise-drug/add-stepwise-drug.component";
import { CreateStepwiseComponent } from "./components/forms/add-stepwise-drug/create-stepwise/create-stepwise.component";
import { EditAnonymousPatientComponent } from "./components/forms/edit-anonymous-patient/edit-anonymous-patient.component";
import { InitPwdComponent } from "./components/forms/init-password/init-password.component";
import { ResetOwnPasswordComponent } from "./components/forms/reset-own-password/reset-own-password.component";
import { VitalSignFormInputComponent } from "./components/forms/vitalSignForm/vital-sign-form-input/vital-sign-form-input.component";
import { VitalSignFormComponent } from "./components/forms/vitalSignForm/vital-sign-form/vital-sign-form.component";
import { GlobalErrorDisplayComponent } from "./components/global-error-display/global-error-display.component";
import { ItemSelectorModule } from "./components/item-selector/item-selector.module";
import { KnowledgeMediaListModalComponent } from "./components/knowledge-media-list-modal/knowledge-media-list-modal.component";
import { LangConflictDialogComponent } from "./components/lang-conflict-dialog/lang-conflict-dialog.component";
import { MfaSetupComponent } from "./components/mfa-setup/mfa-setup.component";
import { NoColumnInfoComponent } from "./components/no-column-info/no-column-info.component";
import { ObservationChartComponent } from "./components/observation-chart/observation-chart.component";
import { ObservationLastAvailableComponent } from "./components/observation-last-available/observation-last-available.component";
import { ObservationSimplifiedAlertsHistoryModalComponent } from "./components/observation-simplified-alerts-history-modal/observation-simplified-alerts-history-modal.component";
import { ObservationSinglePeriodComponent } from "./components/observation-single-period/observation-single-period.component";
import { ObservationValuesDisplayComponent } from "./components/observation-values-display/observation-values-display.component";
import { ObservationSimplifiedComponent } from "./components/observations-simplified/observations-simplified.component";
import { OrgServiceSelectionComponent } from "./components/org-service-selection-dialog/org-service-selection-dialog.component";
import { OrganizationComponent } from "./components/organization/organization.component";
import { AlertDetailsEditComponent } from "./components/patient-alerts/alert-details/alert-details-edit/alert-details-edit.component";
import { AlertDetailsHistoricComponent } from "./components/patient-alerts/alert-details/alert-details-historic/alert-details-historic.component";
import { AlertDetailsComponent } from "./components/patient-alerts/alert-details/alert-details.component";
import { AlertPreferenceComponent } from "./components/patient-alerts/alert-preference/alert-preference.component";
import { RuleAlertComponent } from "./components/patient-alerts/patient-alerts.component";
import { PatientCareplansComponent } from "./components/patient-careplans/patient-careplans.component";
import { PatientCommunicationsComponent } from "./components/patient-communications/patient-communications.component";
import { DocumentModalComponent } from "./components/patient-documents/document-modal/document-modal.component";
import { PatientDocumentsComponent } from "./components/patient-documents/patient-documents.component";
import { AddDrugIntakeDialogComponent } from "./components/patient-drugs/add-drug-intake-dialog/add-drug-intake-dialog.component";
import { DrugAddComponent } from "./components/patient-drugs/drug-add/drug-add.component";
import { DrugCommentComponent } from "./components/patient-drugs/drug-add/drug-comment/drug-comment.component";
import { DrugCycleComponent } from "./components/patient-drugs/drug-add/drug-cycle/drug-cycle.component";
import { DrugServerSideSearchModule } from "./components/patient-drugs/drug-add/drug-server-side-search-component/drug-server-side-search.module";
import { DrugDetailsComponent } from "./components/patient-drugs/drug-details/drug-details.component";
import { DrugExpansionPanelComponent } from "./components/patient-drugs/drug-expansion-panel/drug-expansion-panel.component";
import { DrugGraphComponent } from "./components/patient-drugs/drug-graph/drug-graph.component";
import { DrugStockComponent } from "./components/patient-drugs/drug-stock/drug-stock.component";
import { DrugsCalendarComponent } from "./components/patient-drugs/drugs-calendar/drugs-calendar.component";
import { DrugsHistoricComponent } from "./components/patient-drugs/drugs-historic/drugs-historic.component";
import { PatientDrugsComponent } from "./components/patient-drugs/patient-drugs.component";
import { PatientFormComponent } from "./components/patient-form/patient-form.component";
import { IdentityStatusChangeHistoricComponent } from "./components/patient-infos/identity-status-change-historic/identity-status-change-historic.component";
import { PatientDeactivationUpdateDialogComponent } from "./components/patient-infos/patient-deactivation-update-dialog/patient-deactivation-update-dialog.component";
import { PatientDisableDialogComponent } from "./components/patient-infos/patient-disable-dialog/patient-disable-dialog.component";
import { PatientHistoricDialogComponent } from "./components/patient-infos/patient-historic-dialog/patient-historic-dialog.component";
import { PatientInfoModule } from "./components/patient-infos/patient-infos.module";
import { PatientReactivateDialogComponent } from "./components/patient-infos/patient-reactivate-dialog/patient-reactivate-dialog.component";
import { DefaultObservationTableComponent } from "./components/patient-observations/default-observation-table/default-observation-table.component";
import { HourlyObservationTableComponent } from "./components/patient-observations/hourly-observation-table/hourly-observation-table.component";
import { MirGraphModalComponent } from "./components/patient-observations/mir-graph-modal/mir-graph-modal.component";
import { MomentObservationTableComponent } from "./components/patient-observations/moment-observation-table/moment-observation-table.component";
import { ObservationAlertsHistoryModalComponent } from "./components/patient-observations/observation-alerts-history-modal/observation-alerts-history-modal.component";
import { ObservationStatsContainerComponent } from "./components/patient-observations/observation-stats-container/observation-stats-container.component";
import { ObservationStatsComponent } from "./components/patient-observations/observation-stats-container/observation-stats/observation-stats.component";
import { StatCardComponent } from "./components/patient-observations/observation-stats-container/stat-card/stat-card.component";
import { StatLinechartComponent } from "./components/patient-observations/observation-stats-container/stat-linechart/stat-linechart.component";
import { StatStackedBarplotChartComponent } from "./components/patient-observations/observation-stats-container/stat-stacked-barplot-chart/stat-stacked-barplot-chart.component";
import { StatTableComponent } from "./components/patient-observations/observation-stats-container/stat-table/stat-table.component";
import { PatientObservationsPipesModule } from "./components/patient-observations/patient-observations-pipes/patient-observations-pipes.module";
import { TranslateObservationNamePipe } from "./components/patient-observations/patient-observations-pipes/translate-observation-name.pipe";
import { PatientObservationsStatCardComponent } from "./components/patient-observations/patient-observations-stat-card/patient-observations-stat-card.component";
import { PatientObservationsComponent } from "./components/patient-observations/patient-observations.component";
import { SmallObservationTableComponent } from "./components/patient-observations/small-observation-table/small-observation-table.component";
import { PatientPrescriptionsComponent } from "./components/patient-prescriptions/patient-prescriptions.component";
import { SelectCareplanModalComponent } from "./components/patient-prescriptions/select-careplan-modal/select-careplan-modal.component";
import { AnswerNewQrComponent } from "./components/patient-QR/answer-new-qr/answer-new-qr.component";
import { EncodeQuestionComponent } from "./components/patient-QR/answer-new-qr/encode-question/encode-question.component";
import { ListOfPracQRComponent } from "./components/patient-QR/list-of-prac-qr/list-of-prac-qr.component";
import { PatientQRComponent } from "./components/patient-QR/patient-QR.component";
import { PdfTypeChoiceComponent } from "./components/patient-QR/pdf-type-choice/pdf-type-choice.component";
import { QRDetailsComponent } from "./components/patient-QR/qr-details/qr-details.component";
import { QuestionnaireScoringGraphComponent } from "./components/patient-QR/qr-graph/questionnaireScoringGraph";
import { QRValuePossiblesComponent } from "./components/patient-QR/qr-values-possibles/qr-values-possibles.component";
import { ScoreDetailsComponent } from "./components/patient-QR/score-details/score-details.component";
import { PatientRewardComponent } from "./components/patient-reward/patient-reward.component";
import { RewardDetailsEditComponent } from "./components/patient-reward/reward-details/reward-details-edit/reward-details-edit.component";
import { RewardDetailsHistoricComponent } from "./components/patient-reward/reward-details/reward-details-historic/reward-details-historic.component";
import { RewardDetailsComponent } from "./components/patient-reward/reward-details/reward-details.component";
import { RewardsDialogComponent } from "./components/patient-reward/rewards-dialog/rewards-dialog.component";
import { RiskAssessmentStore } from "./components/patient-risk-assessment/application/risk-assessment.store";
import { PatientRiskAssessmentComponent } from "./components/patient-risk-assessment/patient-risk-assessment.component";
import { PredictionModelImportComponent } from "./components/patient-risk-assessment/prediction-model-import/prediction-model-import.component";
import { RiskAssessmentChartComponent } from "./components/patient-risk-assessment/risk-assessment-details/risk-assessment-chart/risk-assessment-chart.component";
import { RiskAssessmentDetailsComponent } from "./components/patient-risk-assessment/risk-assessment-details/risk-assessment-details.component";
import { PatientTeleconsultationDialogComponent } from "./components/patient-teleconsultations-dialog/patient-teleconsultations-dialog.component";
import { ServerSideSearchComponent } from "./components/patient-teleconsultations-dialog/server-side-search-component/server-side-search.component";
import { PatientTeleconsultationsComponent } from "./components/patient-teleconsultations/patient-teleconsultations.component";
import { PatientVitalSignsComponent } from "./components/patient-vitalSigns/patient-vital-signs.component";
import { VitalSignsHistoricComponent } from "./components/patient-vitalSigns/vital-signs-historic/vital-signs-historic.component";
import { PractitionerSelectorComponent } from "./components/practitioner-selector/practitioner-selector.component";
import { PreferenceDialogComponent } from "./components/preference-dialog/preference-dialog.component";
import { ImportPrescriptionTemplateModalComponent } from "./components/prescription-form/import-prescription-template-modal/import-prescription-template-modal.component";
import { PrescriptionDevicesFormComponent } from "./components/prescription-form/prescription-devices-form/prescription-devices-form.component";
import { PrescriptionFormComponent } from "./components/prescription-form/prescription-form.component";
import { PrescriptionTemplateModalComponent } from "./components/prescription-form/prescription-template-modal/prescription-template-modal.component";
import { RelatedFormComponent } from "./components/related-form/related-form.component";
import { ReleaseNoteDialogComponent } from "./components/release-note-dialog/release-note-dialog.component";
import { RulesListModalComponent } from "./components/rules-list-modal/rules-list-modal.component";
import { ServiceDetailsComponentComponent } from "./components/service-details-component/service-details-component.component";
import { DateIntervalSelectorModule } from "./components/shared/date-interval-selector/date-interval-selector.module";
import { SearchInputComponent } from "./components/shared/search-input/search-input.component";
import { UiDateRangeMaxComponent } from "./components/shared/ui-date-range-max/ui-date-range-max.component";
import { UiFileDropModule } from "./components/shared/ui-file-drop/ui-file-drop.module";
import { UiScrollContainerComponent } from "./components/shared/ui-scroll-container/ui-scroll-container.component";
import { UiSeparatorModule } from "./components/shared/ui-separator/ui-separator.module";
import { ShowHidePasswordComponent } from "./components/show-hide-password/show-hide-password.component";
import { TeleConsultationDialogComponent } from "./components/tele-consultation-dialog/tele-consultation-dialog.component";
import { TopMenuIconsComponent } from "./components/top-menu-icons/top-menu-icons.component";
import { TwoFAModalComponent } from "./components/two-famodal/two-famodal.component";
import { UserInfosComponent } from "./components/user-infos/user-infos.component";
import { UserListDialogComponentComponent } from "./components/user-list-dialog-component/user-list-dialog-component.component";
import { ValueArrayDialogComponent } from "./components/value-array-dialog/value-array-dialog.component";
import { VitalSignsFormComponent } from "./components/vital-signs-form/vital-signs-form.component";
import { WidgetActionsComponent } from "./components/widget-actions/widget-actions.component";
import { WidgetModule } from "./components/widgets/widget.module";
import { DndFilesModule } from "./directives/dnd-files/dnd-files.module";
import { FormsData } from "./helpers/formsData";
import { HelpData } from "./helpers/helpData";
import { UserHelper } from "./helpers/UserHelper";
import { I18nModule } from "./i18n.module";
import { AccessGroupDialogComponent } from "./pages/access-groups-page/access-group-dialog/access-group-dialog.component";
import { AccessGroupComponent } from "./pages/access-groups-page/access-group/access-group.component";
import { AccessGroupsPageComponent } from "./pages/access-groups-page/access-groups-page.component";
import { GroupPermissionsComponent } from "./pages/access-groups-page/group-permissions/group-permissions.component";
import { PractitionerAccessGroupsDialogComponent } from "./pages/access-groups-page/practitioner-access-groups-dialog/practitioner-access-groups-dialog.component";
import { PractitionerAccessGroupsComponent } from "./pages/access-groups-page/practitioner-access-groups/practitioner-access-groups.component";
import { BillingModule } from "./pages/billing/billing.module";
import { CommunicationsPageComponent } from "./pages/communications-page/communications-page.component";
import { CorrespondantPageComponent } from "./pages/correspondant-page/correspondant-page.component";
import { DashboardPageComponent } from "./pages/dashboard-page/dashboard-page.component";
import { DataExtractionComponent } from "./pages/data-extraction/data-extraction.component";
import { ConfirmMailDialogComponent } from "./pages/delete-request-list-page/confirm-mail-dialog/confirm-mail-dialog.component";
import { DeleteRequestListPageComponent } from "./pages/delete-request-list-page/delete-request-list-page.component";
import { DrugSchemaPageComponent } from "./pages/drug-schema-page/drug-schema-page.component";
import { ErrorPageComponent } from "./pages/error-page/error-page.component";
import { GroupsListPageComponent } from "./pages/groups-list-page/groups-list-page.component";
import { IdentityVerifMethodsPageComponent } from "./pages/identity-verif-methods-page/identity-verif-methods-page.component";
import { InstallComunicarePageComponent } from "./pages/install-comunicare-page/install-comunicare-page.component";
import { JournalInsiPageComponent } from "./pages/journal-insi-page/journal-insi-page.component";
import { KnowledgeListContainerPageModule } from "./pages/knowledge-list-page/knowledge-list-container-page.module";
import { LinkPageComponent } from "./pages/link-page/link-page.component";
import { ForgotPasswordModalComponent } from "./pages/login-page/forgot-password-modal/forgot-password-modal.component";
import { LoginPageComponent } from "./pages/login-page/login-page.component";
import { SelectAccountModalComponent } from "./pages/login-page/select-account-modal/select-account-modal.component";
import { LogoutPageModule } from "./pages/logout-page/logout-page.module";
import { MyServicePageComponent } from "./pages/my-service-page/my-service-page.component";
import { NotFoundPageComponent } from "./pages/not-found-page/not-found-page.component";
import { OrganizationListPageComponent } from "./pages/organization-list-page/organization-list-page.component";
import { PatientEditionPageComponent } from "./pages/patient-edition-page/patient-edition-page.component";
import { PatientListPageComponent } from "./pages/patient-list-page/patient-list-page.component";
import { PatientListComponent } from "./pages/patient-list-page/patient-list/patient-list.component";
import { SimplePatientListPageComponent } from "./pages/patient-list-page/simple-patient-list-page/simple-patient-list-page.component";
import { PatientPageComponent } from "./pages/patient-page/patient-page.component";
import { PatientRegistrationPageComponent } from "./pages/patient-registration-page/patient-registration-page.component";
import { PreferencePageComponent } from "./pages/preference-page/preference-page.component";
import { PrescriptionListPageComponent } from "./pages/prescription-list-page/prescription-list-page.component";
import { QuestionnaireDefListPageComponent } from "./pages/questionnaire-def-list-page/questionnaire-def-list-page.component";
import { MobileQuestionnaireListSettingsComponent } from "./pages/questionnaire-list-page/mobile-questionnaire-list-settings/mobile-questionnaire-list-settings.component";
import { QuestionnaireListPageComponent } from "./pages/questionnaire-list-page/questionnaire-list-page.component";
import { QuizListPageComponent } from "./pages/quiz-list-page/quiz-list-page.component";
import { RewardsPageComponent } from "./pages/rewards-page/rewards-page.component";
import { RuleEditorContainerPageModule } from "./pages/rule-editor-page/rule-editor-container-page.module";
import { RuleListContainerPageModule } from "./pages/rule-list-page/rule-list-container-page.module";
import { StatEventsPageComponent } from "./pages/statistics-pages/stat-events-page/stat-events-page.component";
import { StatSummaryPageComponent } from "./pages/statistics-pages/stat-summary-page/stat-summary-page.component";
import { TeleconsultationsPageComponent } from "./pages/teleconsultation-page/teleconsultation-page.component";
import { TemplateQuestionnaireListPageComponent } from "./pages/template-questionnaire-list-page/template-questionnaire-list-page.component";
import { ParticipantModalModule } from "./pages/tpdas-page/modals/participants-modal/participant-modal.module";
import { QuestionnaireResponseModalModule } from "./pages/tpdas-page/modals/questionnaire-responses-modal/qr-modal.module";
import { SendInvitesModalModule } from "./pages/tpdas-page/modals/send-invites-modal/send-invites-modal.module";
import { TpdasPageComponent } from "./pages/tpdas-page/tpdas-page.component";
import { IsPractitionerEnabledPipe, PractitionerToggleTooltipKeyPipe } from "./pages/user-list-page/practitioner-status.pipes";
import { UserListPageComponent } from "./pages/user-list-page/user-list-page.component";
import { UserPageComponent } from "./pages/user-page/user-page.component";
import { FindObsDefByLoincPipe } from "./pipes/find-obs-def-by-loinc.pipe";
import { GetEffectiveTimingPipe } from "./pipes/get-effective-timing.pipe";
import { LoincAndValueMeaningPipe } from "./pipes/loinc-to-itranslation.pipe";
import { PipesModule } from "./pipes/pipes.module";
import { TranslateAlertNamePipe } from "./pipes/sharedAlerts.pipe";
import { ApiService } from "./providers/api/api.service";
import { QuestionnaireApiService } from "./providers/api/questionnaires-api.service";
import { AppointmentService } from "./providers/appointment.service";
import { CareplansService } from "./providers/careplans.service";
import { ConfigService } from "./providers/config.service";
import { GlobalErrorHandler } from "./providers/global-error-handler";
import { HealthcareserviceService } from "./providers/healthcareservice.service";
import { HttpErrorInterceptor } from "./providers/http-error-interceptor";
import { KnowledgeCriteriaService } from "./providers/knowledge-criteria-service";
import { KnowledgeService } from "./providers/knowledge.service";
import { LanguagesService } from "./providers/languages.service";
import { MatPaginatorI18N } from "./providers/mat-paginator-i18n";
import { ObservationsService } from "./providers/observations.service";
import { OrganizationsService } from "./providers/organizations.service";
import { PreferenceService } from "./providers/preference.service";
import { PwaService } from "./providers/pwa.service";
import { QuestionnairesService } from "./providers/questionnaires.service";
import { ResponsiveDialogService } from "./providers/responsive-dialog.service";
import { ResponsiveService } from "./providers/responsive.service";
import { RulesService } from "./providers/rules.service";
import { SessionService } from "./providers/session.service";
import { TileManager } from "./providers/tile-manager.service";
import { UserService } from "./providers/user.service";
import { UserStatisticsService } from "./providers/userStatistics.service";

/**
 * Factory for the `APP_INITIALIZER` provider that boots the app's core async dependencies
 * in a strict, guaranteed order.
 *
 * Order matters here: `TranslateService` (and its loader chain, `CustomI18nTranslateLoader`
 * → `LanguageService` → `ApiService`) must not be constructed until `ConfigService.load()`
 * has fully resolved, since `ApiService` relies on config values (e.g. `apiUrl`) being
 * available.
 *
 * To achieve this, `TranslateService` and `SessionService` are intentionally **not** listed
 * in `deps`. Angular resolves all `deps` synchronously when building the list of
 * `APP_INITIALIZER` factories, which would instantiate `TranslateService` (and therefore
 * `ApiService`) immediately — before `configService.load()` has finished, even though this
 * factory itself runs later. Instead, only the generic `Injector` is injected, and the
 * actual dependent services are resolved manually via `injector.get(...)` inside the async
 * function body, strictly after the `await configService.load()` call. This guarantees the
 * config is fully loaded before `TranslateService` (and its dependency chain) is created.
 *
 * @param configService - Service responsible for loading app configuration (e.g. `apiUrl`)
 *   before anything else that depends on it is instantiated.
 * @param injector - The root `Injector`, used to lazily resolve `TranslateService` and
 *   `SessionService` only after config has loaded, avoiding premature instantiation of their
 *   dependency chain.
 * @returns A factory function invoked by Angular's `APP_INITIALIZER` mechanism. The returned
 *   promise resolves once both config loading and the initial translation setup are complete;
 *   Angular delays app bootstrap until it resolves.
 */
function initApp(configService: ConfigService, injector: Injector): () => Promise<void> {
  return async () => {
    // Step 1: load app configuration first (e.g. apiUrl) — everything else depends on it.
    console.log("initApp");
    await configService.load();
    console.log("initApp - load");

    // Step 2: only now resolve TranslateService, which lazily triggers construction of
    // CustomI18nTranslateLoader -> LanguageService -> ApiService, guaranteeing config
    // is already available by the time ApiService is built.
    const translateService = injector.get(TranslateService);
    const sessionService = injector.get(SessionService);

    // languages list
    translateService.addLangs(["fr", "en", "nl", "de", "it", "pt"]);
    // this language will be used as a fallback when a translation isn't found in the current language
    translateService.setDefaultLang("en");

    if (sessionService.userLang) {
      await translateService.use(sessionService.userLang).toPromise();
    } else {
      await translateService.use(translateService.getBrowserLang()).toPromise();
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    DashboardPageComponent,
    NotFoundPageComponent,
    GlobalErrorDisplayComponent,
    PatientListPageComponent,
    UserListPageComponent,
    IsPractitionerEnabledPipe,
    PractitionerToggleTooltipKeyPipe,
    ChangeLangComponent,
    UserInfosComponent,
    LangConflictDialogComponent,
    PatientPageComponent,
    TeleConsultationDialogComponent,
    PatientCareplansComponent,
    PatientObservationsComponent,
    ObservationChartComponent,
    PatientDrugsComponent,
    DrugDetailsComponent,
    RuleAlertComponent,
    CareplanComponent,
    CareplanActivityComponent,
    AlertDetailsComponent,
    AlertDetailsEditComponent,
    AlertDetailsHistoricComponent,
    PatientVitalSignsComponent,
    VitalSignsHistoricComponent,
    PatientQRComponent,
    QRDetailsComponent,
    TeleconsultationsPageComponent,
    PatientTeleconsultationsComponent,
    PatientTeleconsultationDialogComponent,
    PatientVitalSignsComponent,
    ServerSideSearchComponent,
    InitPwdComponent,
    QRValuePossiblesComponent,
    QuestionnaireScoringGraphComponent,
    OrganizationListPageComponent,
    OrganizationComponent,
    UserListDialogComponentComponent,
    ServiceDetailsComponentComponent,
    AddOrganizationComponent,
    PreferenceDialogComponent,
    AddServiceComponent,
    MyServicePageComponent,
    ReleaseNoteDialogComponent,
    AddToGroupDialogComponent,
    GroupServerSideSearchComponent,
    AnswerNewQrComponent,
    ListOfPracQRComponent,
    GroupsListPageComponent,
    AddGroupComponent,
    ErrorPageComponent,
    EditAnonymousPatientComponent,
    QuestionnaireListPageComponent,
    ScoreDetailsComponent,
    DrugAddComponent,
    DrugsHistoricComponent,
    AddCommunicationComponent,
    CommunicationsPageComponent,
    CommunicationOverviewComponent,
    PatientCommunicationsComponent,
    PatientRiskAssessmentComponent,
    RiskAssessmentDetailsComponent,
    RiskAssessmentChartComponent,
    GroupSearchOnlyComponent,
    RewardsPageComponent,
    RewardsDialogComponent,
    PatientRewardComponent,
    RewardDetailsEditComponent,
    RewardDetailsHistoricComponent,
    RewardDetailsComponent,
    TemplateQuestionnaireListPageComponent,
    QuestionnaireDefListPageComponent,
    PatientAlreadyExistsDialogComponent,
    ChooseInsuranceDialogComponent,
    ConfirmResetPasswordDialogComponent,
    ConfirmTogglePractitionerDialogComponent,
    ErrorGeneratePasswordComponent,
    ErrorOnGettingCaremateIDComponent,
    DisplayAuthcodeConfirmationComponent,
    DisplayEnvironementDialogComponent,
    KnowledgeCreationDialogComponent,
    AddDrugSchemaComponent,
    PauseDrugSchemaComponent,
    DrugSchemaPageComponent,
    DrugCycleComponent,
    DrugsCalendarComponent,
    AlertPreferenceComponent,
    PatientDisableDialogComponent,
    PatientReactivateDialogComponent,
    PatientDeactivationUpdateDialogComponent,
    PatientHistoricDialogComponent,
    ValueArrayDialogComponent,
    VitalSignFormComponent,
    VitalSignFormInputComponent,
    QuizListPageComponent,
    DisplayPicturesComponent,
    DeleteRequestListPageComponent,
    ConfirmMailDialogComponent,
    MfaSetupComponent,
    TwoFAModalComponent,
    DefinitionListComponent,
    MomentObservationTableComponent,
    HourlyObservationTableComponent,
    DrugCommentComponent,
    PatientDocumentsComponent,
    DocumentModalComponent,
    AccessGroupsPageComponent,
    GroupPermissionsComponent,
    AccessGroupComponent,
    AccessGroupDialogComponent,
    PractitionerAccessGroupsComponent,
    PractitionerAccessGroupsDialogComponent,
    UserPageComponent,
    NoColumnInfoComponent,
    AnsPractitionnerResultComponent,
    TownServerSideSearchComponent,
    IdentityStatusChangeHistoricComponent,
    CorrespondantPageComponent,
    StatSummaryPageComponent,
    StatEventsPageComponent,
    JournalInsiPageComponent,
    ResetOwnPasswordComponent,
    ForgotPasswordModalComponent,
    SelectAccountModalComponent,
    AddStepwiseDrugComponent,
    ShowHidePasswordComponent,
    SimplePatientListPageComponent,
    PatientListComponent,
    CreateStepwiseComponent,
    ObservationStatsContainerComponent,
    StatCardComponent,
    StatLinechartComponent,
    StatStackedBarplotChartComponent,
    StatTableComponent,
    ObservationStatsComponent,
    ObservationStatsContainerComponent,
    DefaultObservationTableComponent,
    SmallObservationTableComponent,
    AppointmentDelayComponent,
    AppointmentDelayDialogComponent,
    PractitionerSelectorComponent,
    IdentityVerifMethodsPageComponent,
    ObservationAlertsHistoryModalComponent,
    UiScrollContainerComponent,
    DataExtractionComponent,
    TopMenuIconsComponent,
    CareplansListPageComponent,
    EncodeQuestionComponent,
    PredictionModelImportComponent,
    KnowledgeMediaListModalComponent,
    PdfTypeChoiceComponent,
    AddDrugIntakeDialogComponent,
    DrugGraphComponent,
    UiDateRangeMaxComponent,
    StreamObsChartComponent,
    StreamObsStatChartComponent,
    PatientObservationsStatCardComponent,
    DrugStockComponent,
    OrgServiceSelectionComponent,
    WidgetActionsComponent,
    MirGraphModalComponent,
    InstallComunicarePageComponent,
    DrugExpansionPanelComponent,
    SearchInputComponent,
    MobileQuestionnaireListSettingsComponent,
    PatientRegistrationPageComponent,
    PatientFormComponent,
    RelatedFormComponent,
    PreferencePageComponent,
    PrescriptionFormComponent,
    PrescriptionDevicesFormComponent,
    PatientPrescriptionsComponent,
    SelectCareplanModalComponent,
    PrescriptionTemplateModalComponent,
    ImportPrescriptionTemplateModalComponent,
    PrescriptionListPageComponent,
    VitalSignsFormComponent,
    PatientEditionPageComponent,
    TpdasPageComponent,
    RulesListModalComponent,
    ObservationSimplifiedComponent,
    ObservationLastAvailableComponent,
    ObservationSinglePeriodComponent,
    ObservationValuesDisplayComponent,
    ObservationSimplifiedAlertsHistoryModalComponent,
    LinkPageComponent,
  ],
  imports: [
    BrowserModule,
    I18nModule,
    CareplanEditorPageModule, // Module containing specific routing must be imported before AppRoutingModule or the wild card ** will be triggered before the paths defined in that module.
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDatepickerModule,
    DragDropModule,
    MatCheckboxModule,
    ItemFilterModule,
    FiltersDisplayModule,
    PatientInfoModule,
    MatDialogModule,
    FormsData,
    MatTooltipModule,
    UserHelper,
    WidgetModule,
    DateIntervalSelectorModule,
    MatSlideToggleModule,
    MatSliderModule,
    ChartsModule,
    MatSnackBarModule,
    MatTabsModule,
    MatStepperModule,
    NgxMatSelectSearchModule,
    MatGridListModule,
    HelpData,
    MatAutocompleteModule,
    MatRadioModule,
    MatExpansionModule,
    NgxMaterialTimepickerModule,
    JoditAngularModule,
    MatChipsModule,
    ClipboardModule,
    KnowledgeListPipesModule,
    PipesModule,
    MatMenuModule,
    MatChipsModule,
    NgxMatMomentModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    MdePopoverModule,
    MatChipsModule,
    MatButtonToggleModule,
    PatientObservationsPipesModule,
    KnowledgeListContainerPageModule,
    RuleListContainerPageModule,
    RuleEditorContainerPageModule,
    LogoutPageModule,
    WhenInputModule,
    DndFilesModule,
    DrugServerSideSearchModule,
    UiAlertModule,
    StarRatingModule,
    TimingEditorModule,
    UiFileDropModule,
    MatBadgeModule,
    UiSeparatorModule,
    KnowledgeMediaListModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production || environment.envName === "dev" || environment.envName === "test",
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
    BillingModule,
    ItemSelectorModule,
    QuestionnaireEditorPageModule,
    ParamEditorModule,
    EmailInputModule,
    PhoneInputModule,
    ImageViewerComponentModule,
    GlobalHelpDialogModule,
    EncodeObservationsComponentModule,
    FhirQuestionnaireListPageModule,
    FiltersDisplayModule,
    ConfirmationDialogModule,
    WarningBoxDialogModule,
    PhotoBoothDialogComponentModule,
    PagesEditorComponentModule,
    KnowledgeDetailsPageModule,
    KnowledgeMediaEditorModule,
    DraftWarningDialogModule,
    MediaSelectorDialogModule,
    KnowledgeServicesModule,
    KnowledgeCriteriaModule,
    KnowledgeComparisonDialogModule,
    KnowledgeOverviewModule,
    ParticipantModalModule,
    QuestionnaireResponseModalModule,
    SendInvitesModalModule,
    MatMomentDateModule,
  ],
  providers: [
    ApiService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [ConfigService, Injector],
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: MatPaginatorIntl, useClass: MatPaginatorI18N },

    { provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    CookieService,
    TranslateObservationNamePipe,
    TileManager,
    TranslateAlertNamePipe,
    LoincAndValueMeaningPipe,
    GetEffectiveTimingPipe,
    FindObsDefByLoincPipe,
    MatIconRegistry,
    FileLogger,
    DecimalPipe,
    DatePipe,
    RiskAssessmentStore,
    PwaService,
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        disableTooltipInteractivity: true,
      },
    },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: { dateInput: "L" },
        display: {
          dateInput: "L",
          monthYearLabel: "MMM YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "MMMM YYYY",
        },
      },
    },
    { provide: USER_SERVICE, useExisting: UserService },
    { provide: SESSION_SERVICE, useExisting: SessionService },
    { provide: LANGUAGE_SERVICE, useExisting: LanguagesService },

    { provide: QUESTIONNAIRE_SERVICE, useExisting: QuestionnairesService },

    { provide: KNOWLEDGE_SERVICE, useExisting: KnowledgeService },
    { provide: CAREPLAN_SERVICE, useExisting: CareplansService },
    { provide: OBSERVATION_SERVICE, useExisting: ObservationsService },
    { provide: PREFERENCE_SERVICE, useExisting: PreferenceService },
    { provide: QUESTIONNAIRE_API_SERVICE, useExisting: QuestionnaireApiService },
    { provide: HEALTHCARESERVICE_SERVICE, useExisting: HealthcareserviceService },

    { provide: ORGANIZATION_SERVICE, useExisting: OrganizationsService },
    { provide: CAREPLAN_EDITOR_SERVICE, useExisting: CareplanEditorService },
    { provide: RESPONSIVE_DIALOG_SERVICE, useExisting: ResponsiveDialogService },
    { provide: RESPONSIVE_SERVICE, useExisting: ResponsiveService },
    { provide: HELP_DATA_SERVICE, useExisting: HelpData },
    { provide: USER_STAT_SERVICE, useExisting: UserStatisticsService },
    { provide: APPOINTMENT_SERVICE, useExisting: AppointmentService },
    { provide: KNOWLEDGE_CRITERIA_SERVICE, useExisting: KnowledgeCriteriaService },
    { provide: RULE_SERVICE, useExisting: RulesService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
